<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowURightTopBold } from "@mdi/js";
export default {
  name: "MdiUndoVariant",
  data() {
    return {
      svgPath: mdiArrowURightTopBold,
    };
  },
};
</script>
